import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-offer-box",
  templateUrl: "./offer-box.component.html",
  styleUrls: ["./offer-box.component.css"],
})
export class OfferBoxComponent implements OnInit {
  @Input() title: string;
  @Input() productDetail: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  email: any;
  constructor(private activeModal: NgbActiveModal, private http: HttpClient) {}
  spendAndSafeOfferData: any = [];
  bannerAdData: any = [];
  ProductOfferDetails = [];
  buy1get1Offer = null;
  ngOnInit() {
    this.buy1get1Offer = this.productDetail.buy1get1;
    this.productDetail.field.forEach((element: any) => {
      if (element.code_value == "Price") {
        this.ProductOfferDetails = element.subFields;
      }
    });
    this.getSpendAndSafeOffer();
    this.getBannerAdOffer(this.productDetail.categories_id);
  }

  getSpendAndSafeOffer() {
    this.http
      .get(environment.URL + "/banner/spenOffersList")
      .subscribe((res: any) => {
        this.spendAndSafeOfferData = res.data;
      });
  }
  getBannerAdOffer(id) {
    this.http
      .get(environment.URL + "/banner/bannerAd/" + id)
      .subscribe((res: any) => {
        this.bannerAdData = res.data;
      });
  }

  public decline() {
    this.activeModal.close();
  }

  public accept() {
    this.activeModal.close();
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  convertToPrice(value) {
    return parseFloat(value).toFixed(2);
  }
}
